module.exports = __webpack_public_path__ + "static/img/1-07-3.ba705a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/1-07-3.png
// module id = D2HL
// module chunks = 1